<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...$$props}>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="m11.177 5.362.513 4.26 1.967-.2-.854-7.1-7.1-.854-.2 1.967 4.26.512-8.273 8.274 1.414 1.414z"
    clip-rule="evenodd"
  />
</svg>
